import { useRouter as useTanStackRouter } from '@tanstack/react-router';
import { useMemo } from 'react';

export interface Router {
  back: () => void;
  forward: () => void;
  refresh: () => void;
  push: (href: string) => void;
  replace: (href: string) => void;
}

export function useRouter() {
  const router = useTanStackRouter();

  const customRouter = useMemo(
    () => ({
      back: () => window.history.back(),
      forward: () => window.history.forward(),
      refresh: () => window.location.reload(),
      push: (href: string) => router.navigate({ to: href }),
      replace: (href: string) => router.navigate({ to: href, replace: true }),
    }),
    [router],
  );

  return customRouter;
}
